<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<!-- <v-tabs v-model="params.tab" grow>
							<v-tabs-slider color="yellow"></v-tabs-slider>
							<v-tab tab-value="number">Номер</v-tab>
							<v-tab tab-value="vin">VIN</v-tab>
						</v-tabs>
						<v-tabs-items v-model="params.tab" class="pt-3">
							<v-tab-item value="number">
								<v-text-field
									label="Реєстраційний номер"
									v-model.trim="params.number"
									outlined
									dense
									clearable
									:rules="[rules.requiredNumber]"
									@keyup.ctrl.90="params.number='ab9999it'"
									hide-details="auto"
								></v-text-field>
							</v-tab-item>
							<v-tab-item value="vin">
								<v-text-field
									label="VIN-код"
									v-model.trim="params.vin"
									outlined
									dense
									clearable
									:rules="[rules.requiredVIN]"
									@keyup.ctrl.90="params.vin='WAUZZZ4M0HD001505'"
									hide-details="auto"
								></v-text-field>
							</v-tab-item>
						</v-tabs-items> -->
						<z-vehicle-number-vin
							v-model="params.numbervin"
							outlined
							dense
							clearable
							:rules="rules"
							default-vin="WAUZZZ4M0HD001505"
						></z-vehicle-number-vin>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- Favorit -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-if="isFavorit" color="yellow-darken-1" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star</v-icon>
            					<v-icon v-else class="opacity-30" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star-outline</v-icon>
							</template>
							<span>Вибране</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- Excel -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 256px;">
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }} {{ id ? '№' + id: '' }}
				</v-card-title>

				<v-divider></v-divider>

				<v-simple-table dense>
					<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left">Назва</th>
								<th class="text-left">Значення</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in registrations" :key="item.code">
								<td>{{ item.name }}</td>
								<td>{{ item.val }}</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :item="item"></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/parameters'
import downloadExcel from "vue-json-excel"
import zPdf from '@/views/pdf/VehicleAutoParams'
import zVehicleNumberVin from '@/views/components/control/VehicleNumberVin'

export default {
	name: 'VehicleAutoParams',
	mixins: [mixin],
	components: {
		zVehicleNumberVin,
		zPdf,
		downloadExcel,
	},
	data: () => ({
		title: 'Параметри транспортного засобу з оголошень',
		loading: false,

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},
	}),
	
	computed: {
		...mapGetters('VehicleAutoParams', [ 'item' ]),

		id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		},

		favorit() {
			return this.favorits.find(element => element.id === this.id);
		},

		excelName() {
			return this.title + (this.params.regnum ? ' ' + this.params.regnum : (this.params.vin ? ' ' + this.params.vin : '') + '.' +  this.excelType)
		},

		// Дані про державну реєстрацію транспортного засобу
		registrations() {
			return this.item?.registrations ? this.item.registrations: [];
		},
	},

	methods: {
		...mapActions('VehicleAutoParams', [ 'setItem' ]),

		onClear() {
			this.$refs.form.reset()
		},

		onOK() {
			var that = this
			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'onOK', 'VALID')
				this.loading = true

				this.setItem()

				//let params = this.params.tab == 'number' ? { number: this.params.number } : { vin: this.params.vin };

				let params = this.isLicensePlate(this.params.numbervin) ? { number: this.params.numbervin } : { vin: this.params.numbervin };

				axios.post('/vehicle/estimate/auto/params', params).then(response => {
					//console.log(that.$options.name, 'onOK','response', response)
					//console.log(that.$options.name, 'onOK','response.data', response.data)

					that.setItem(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onFavorit() {
			if(this.favorit) {
				this.removeFavorit(this.favorit) 
			} else {
				//console.log(this.$options.name, 'onFavorit','item', this.item)

				let number 	= this.item.number;
				let vin 	= this.item.vin;

				let code = `Ria:${number?number:''}:${vin?vin:''}`;
				//let name = number?number:(vin?vin:'ТЗ');
				let name = this.params?.numbervin ? this.params.numbervin : (number?number:(vin?vin:'ТЗ'))

				let favorit = {
					id: this.item.id,
					code: code,
					name: name,
					number: number,
					vin: vin,
					category: this.item.category,
					brand: this.item.brand, 
					model: this.item.model,
					generation: this.item.generation,
					modification: this.item.modification,
					yearProd: this.item.yearProd,
					yearProdFrom: this.item.yearProdFrom,
					yearProdTo: this.item.yearProdTo,
					bodystyle: this.item.bodystyle,
					//color: this.item.color,
					fuel: this.item.fuel,
					driver: this.item.driver,
					engineVolume: this.item.engineVolume,
					engineVolumeFrom: this.item.engineVolumeFrom,
					engineVolumeTo: this.item.engineVolumeTo,
					gearbox: this.item.gearbox,
					mileage: this.item.mileage,
					mileageFrom: this.item.mileageFrom,
					mileageTo: this.item.mileageTo,
					state: this.item.state,
				}

				//console.log(this.$options.name, 'onFavorit','favorit', favorit)

				this.addFavorit(favorit)
			}
		},
		
		onPDF () {
			this.$refs.pdf.generate()
		}
	},
}
</script>